// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"vendors-node_modules_aos_dist_aos_js":"c92ee725839eeba83997","vendors-node_modules_fancyapps_ui_dist_index_esm_js":"cfab7268694fb4a6b682","vendors-node_modules_swiper_swiper-bundle_mjs":"0f5dd579470c22c34efb"}[chunkId] + ".js";
};